export default __webpack_public_path__ + "static/media/group-5909.46fb8076.png";